/**
 * pp-search-overlay.js
 * Angara-style full-screen search overlay with predictive results
 */
(function () {
  'use strict';

  var overlay   = document.getElementById('pp-search-overlay');
  var input     = document.getElementById('pp-search-input');
  var closeBtn  = document.getElementById('pp-search-close');
  var clearBtn  = document.getElementById('pp-search-clear');
  var defaultEl = document.getElementById('pp-search-default');
  var resultsEl = document.getElementById('pp-search-results');
  var resultsGrid = document.getElementById('pp-search-results-grid');
  var resultsLink = document.getElementById('pp-search-results-link');
  var emptyEl   = document.getElementById('pp-search-empty');
  var loadingEl = document.getElementById('pp-search-loading');

  if (!overlay || !input) return;

  var debounceTimer = null;
  var currentQuery = '';

  // ── Open / Close ──────────────────────────────────────────────────────────

  function openOverlay() {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeOverlay() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    currentQuery = '';
    showDefault();
  }

  // ── State helpers ─────────────────────────────────────────────────────────

  function showDefault() {
    defaultEl.hidden  = false;
    resultsEl.hidden  = true;
    emptyEl.hidden    = true;
    loadingEl.hidden  = true;
    clearBtn.hidden   = true;
  }

  function showLoading() {
    defaultEl.hidden  = true;
    resultsEl.hidden  = true;
    emptyEl.hidden    = true;
    loadingEl.hidden  = false;
  }

  function showResults(products, query) {
    loadingEl.hidden = true;

    if (!products || products.length === 0) {
      defaultEl.hidden = true;
      resultsEl.hidden = true;
      emptyEl.hidden   = false;
      return;
    }

    resultsGrid.innerHTML = products.map(function (p) {
      var img = p.featured_image
        ? '<img src="' + p.featured_image.url + '" alt="' + escHtml(p.title) + '" loading="lazy">'
        : '<svg viewBox="0 0 24 24" width="100%" height="100%"><rect width="24" height="24" fill="#f0ebe3"/></svg>';

      var price = p.price
        ? '₹' + Number(parseFloat(p.price)).toLocaleString('en-IN')
        : (p.price_min ? '₹' + Number(parseFloat(p.price_min)).toLocaleString('en-IN') : '');

      return '<a href="' + p.url + '" class="pp-search-overlay__product-card">'
        + '<div class="pp-search-overlay__product-img">' + img + '</div>'
        + '<p class="pp-search-overlay__product-title">' + escHtml(p.title) + '</p>'
        + '<p class="pp-search-overlay__product-price">' + price + '</p>'
        + '</a>';
    }).join('');

    if (resultsLink) {
      resultsLink.href = '/search?type=product&q=' + encodeURIComponent(query);
      resultsLink.textContent = 'See all results for "' + query + '"';
    }

    defaultEl.hidden = true;
    emptyEl.hidden   = true;
    resultsEl.hidden = false;
  }

  // ── Predictive search ─────────────────────────────────────────────────────

  function fetchResults(query) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide'
      + '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag,vendor';

    fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (query !== currentQuery) return; // stale response
        var products = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        showResults(products, query);
      })
      .catch(function () {
        if (query !== currentQuery) return;
        showDefault();
      });
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  function escHtml(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '₹' + Number(amount).toLocaleString('en-IN');
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  // Trigger ONLY from header / drawer search — NOT from the search results page's own input
  document.querySelectorAll('.pp-header__search-input, .pp-drawer__search-input').forEach(function (el) {
    // Skip if this input is inside the search results page form
    if (el.closest('.template-search__search, main-search')) return;
    el.addEventListener('focus', function (e) {
      e.preventDefault();
      openOverlay();
    });
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openOverlay();
    });
  });

  // Trigger from search icon buttons
  document.querySelectorAll('.pp-header__search-submit').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openOverlay();
    });
  });

  // Close
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

  // Backdrop click
  var backdrop = overlay.querySelector('.pp-search-overlay__backdrop');
  if (backdrop) backdrop.addEventListener('click', closeOverlay);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
  });

  // Clear button
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      currentQuery = '';
      clearBtn.hidden = true;
      showDefault();
      input.focus();
    });
  }

  // Input handler
  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      currentQuery = q;
      clearBtn.hidden = q.length === 0;

      clearTimeout(debounceTimer);

      if (q.length < 2) {
        showDefault();
        return;
      }

      showLoading();

      debounceTimer = setTimeout(function () {
        fetchResults(q);
      }, 280);
    });

    // Enter: just fetch more results, do NOT navigate away
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q.length >= 2) {
          clearTimeout(debounceTimer);
          fetchResults(q);
        }
      }
    });
  }

})();
